import React from 'react';
import { NudosButton } from 'components/NudosComponents';
import './ButtonCancelOrders.scss';
const ButtonCancelOrders = ({
  handleClick,
  buttonText,
  customClassName = '',
  isDisabled,
  showCanceledOrders
}: IButtonCancelOrders) => {
  return (
    <div className="buttonCancelOrdersContainer">
      {showCanceledOrders && <div className="floatAnimationCanceledOrders floatAnimationRed" />}
      <NudosButton
        buttonText={buttonText}
        handleClick={handleClick}
        colorPalette="secondary"
        customClassName={`buttonCancelOrders ${customClassName} ${showCanceledOrders ? 'showCanceledOrders' : ''}`}
        isButtonDisabled={isDisabled}
      />
    </div>
  );
};

interface IButtonCancelOrders {
  handleClick: () => void;
  buttonText: string;
  customClassName?: string;
  isDisabled?: boolean;
  showCanceledOrders?: boolean;
}
export default ButtonCancelOrders;
